import { render } from "./MenuItem.vue?vue&type=template&id=d8fbde48&ts=true"
import script from "./MenuItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./MenuItem.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Shared/components/primitives/menu/MenuItem.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d8fbde48"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d8fbde48', __exports__)) {
    api.reload('d8fbde48', __exports__)
  }
  
  module.hot.accept("./MenuItem.vue?vue&type=template&id=d8fbde48&ts=true", () => {
    api.rerender('d8fbde48', render)
  })

}


export default __exports__